import { render, staticRenderFns } from "./OrderComment.vue?vue&type=template&id=370be2e0&scoped=true"
import script from "./OrderComment.vue?vue&type=script&lang=js"
export * from "./OrderComment.vue?vue&type=script&lang=js"
import style0 from "./OrderComment.vue?vue&type=style&index=0&id=370be2e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370be2e0",
  null
  
)

export default component.exports